<template>
  <div>
    <h2>Unimplemented Input Field!</h2>
    <p>
      If you are seeing this, development made a mistake or has not implemted a
      view for this component yet. Please notify development if you see this!
    </p>
  </div>
</template>

<script>
export default {
  name: 'unknown-input-field',
  inputType: 'unknown',
  props: ['value'],
  data: function () {
    return {}
  }
}
</script>
